import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Modal,
  Radio,
  Row,
  Switch,
  Input,
  Collapse,
  Divider,
  Upload,
  Button,
  message,
} from "antd";
import image from "../../../../assets/images/robot_img.png";
import { MessageOutlined } from "@ant-design/icons";
import { appearanceModel } from "../../constants";
import ImageModal from "./AttentionGrabber/components/ImagesModal/index";
import { UploadOutlined } from "@ant-design/icons";
import useAWSUpload from "../../../../hooks/useAWSUpload";
import ImageContainer from "../../../../components/ImageContainer";
import "./index.css";

const { TextArea } = Input;
const { Panel } = Collapse;

const WidgetAppearance = ({ widget, handleWidgetChange }) => {
  const [getSignedUrl, uploadFile] = useAWSUpload();
  const [showModal, setModal] = useState(false);
  const [appearance, setAppearance] = useState({ ...appearanceModel });
  const [selectedImage, setSelectedImage] = useState(null);
  const [preChatVisuals, setPreChatVisuals] = useState(false);
  const [preChatImage, setPreChatImage] = useState(null);
  const [preChatImageFromDB, setPreChatImageFromDB] = useState(null);

  const [preChatPreview, setPreChatImagePreview] = useState();
  const [preChatHeading, setPreChatHeading] = useState();

  const [preChatText, setPreChatText] = useState();

  const [modalVisible, setModalVisible] = useState(false);
  const [attGrab, setAttGrab] = useState(false);

  useEffect(() => {
    resetAppearance();
  }, [widget.id, widget.appearance]);

  const setPreChatSettings = async (appearance) => {
    if (appearance?.preChatSettings) {
      let imgPreChat = await getSignedUrl(
        appearance?.preChatSettings?.image?.key
      );
      setPreChatImageFromDB(appearance?.preChatSettings?.image);
      setPreChatImagePreview(imgPreChat);
      setPreChatHeading(appearance?.preChatSettings?.heading);
      setPreChatText(appearance?.preChatSettings?.text);

      return;
    }
  };
  const resetAppearance = () => {
    if (widget.appearance) {
      setAppearance(widget.appearance);
      setSelectedImage(widget.appearance?.attentionGrabber);
      setAttGrab(widget.appearance?.attentionGrabberEnabled);
      setPreChatSettings(widget?.appearance);
    } else setAppearance({ ...appearanceModel });
  };

  const handleAppearanceChange = (event) => {
    setAppearance((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSave = async () => {
    if (preChatImage || preChatImageFromDB) {
      let imageData = preChatImageFromDB;
      if (preChatImage) {
        imageData = await uploadFile(preChatImage);
      }

      let updatedApperance = {
        ...appearance,
        attentionGrabberEnabled: selectedImage != null ? attGrab : false,
        attentionGrabber: selectedImage,
        preChatSettings: {
          image: imageData,
          heading: preChatHeading ?? "Welcome to chat",
          text: preChatText ?? "We just need some basic information",
        },
      };

      handleWidgetChange({ appearance: updatedApperance, id: widget.id });
      setModal(false);
      setPreChatVisuals(false);
    } else {
      let updatedApperance = {
        ...appearance,
        attentionGrabberEnabled: selectedImage != null ? attGrab : false,
        attentionGrabber: selectedImage,
      };
      handleWidgetChange({ appearance: updatedApperance, id: widget.id });
      setModal(false);
    }
  };

  const bubbleImages = [
    {
      id: 1,
      image:
        "https://embed.tawk.to/_s/v4/assets/images/attention-grabbers/168-r-br.svg",
      type: "bubble",
    },
  ];

  const tabImages = [
    {
      id: 1,
      image: "https://dashboard.tawk.to/_s/assets/images/bubbles/168-br.svg",
      type: "tab",
    },
  ];

  const handleImageSelect = (image) => {
    setSelectedImage(image);
    setModalVisible(false); // Close the modal after selecting an image
  };

  const openModal = () => {
    setModalVisible(true);
  };

  useEffect(() => {
    if (appearance) {
      if (appearance.style !== selectedImage?.type) {
        setSelectedImage(null);
      }
    }
  }, [appearance]);

  const handlePreChatImage = async (file) => {};
  const beforeUpload = (file) => {
    setPreChatImage(file);
    try {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        message.error("You can only upload image files!");
        return false;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreChatImagePreview(reader.result);
      };
      reader.readAsDataURL(file);

      return false;
    } catch (error) {
      console.error("Error reading image:", error);

      return false;
    }
  };

  const uploadProps = {
    name: "file",
    action: handlePreChatImage,
    showUploadList: false,
  };
  return (
    <div>
      <Card className="setting_wrapper">
        <Row className="flex_items">
          <Col span={12}>
            <h4 className="p-color">Widget Appearance</h4>
          </Col>
          <Col
            span={12}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <span className="advance_btn" onClick={() => setModal(!showModal)}>
              Customize
            </span>
          </Col>
        </Row>
      </Card>

      {showModal && (
        <Modal
          centered
          open={showModal}
          onOk={handleSave}
          onCancel={() => {
            setModal(false);
            setPreChatVisuals(false);
            resetAppearance();
          }}
          cancelText="Close"
          okText="Save"
          width={800}
          style={{ backgroundColor: "#F7F7F9" }}
          className="adv_modal"
          title=""
        >
          <Row gutter={[16, 16]}>
            <Col span={12} className="">
              <h4>WIDGET APPEARANCE</h4>

              <div className="widget_type">
                <Radio.Group
                  name="style"
                  className="radio_group"
                  value={appearance.style}
                >
                  <Radio value="bubble" onChange={handleAppearanceChange}>
                    <div
                      className="widget-bubble"
                      style={{ backgroundColor: appearance.color }}
                    >
                      <MessageOutlined />
                    </div>
                  </Radio>
                  <Radio value="tab" onChange={handleAppearanceChange}>
                    <div
                      className="widget-tab"
                      style={{ backgroundColor: appearance.color }}
                    >
                      <span>Online</span>
                    </div>
                  </Radio>
                </Radio.Group>
              </div>

              <div className="widget_position flex_between">
                <h4>Widget Position</h4>
                <div className="btns_group">
                  <Radio.Group
                    name="position"
                    onChange={handleAppearanceChange}
                    value={appearance.position}
                  >
                    <Radio.Button value="left">Left</Radio.Button>
                    <Radio.Button value="right">Right</Radio.Button>
                  </Radio.Group>
                </div>
              </div>

              <div className="widget_color flex_between">
                <h4>Widget Color</h4>
                <input
                  style={{
                    width: "124px",
                    height: "40px",
                  }}
                  type="color"
                  name="color"
                  value={appearance.color}
                  onChange={handleAppearanceChange}
                />
              </div>

              <div className="widget_position flex_between">
                <h4>Widget Title</h4>
                <div className="btns_group">
                  <Input
                    name="title"
                    value={appearance?.title}
                    placeholder="Enter Widget title"
                    onChange={handleAppearanceChange}
                  />
                </div>
              </div>
              <div className="widget_color flex_between">
                <div className="flex_items">
                  <h4>Attention Grabber</h4>
                  <ImageModal
                    visible={modalVisible}
                    images={
                      appearance.style === "bubble" ? bubbleImages : tabImages
                    }
                    onSelect={handleImageSelect}
                    onClose={() => setModalVisible(false)}
                  />
                  <Switch
                    className="att-grab-switch"
                    onChange={(e) => {
                      setAttGrab(e);
                    }}
                    defaultChecked={appearance?.attentionGrabberEnabled}
                    checked={attGrab}
                  />
                </div>

                <button disabled={!attGrab} onClick={openModal}>
                  Select Image
                </button>
              </div>

              <div className="widget_color flex_between">
                <Collapse
                  onChange={(e) => {
                    if (e?.length === 0) {
                      setPreChatVisuals(false);
                    } else {
                      setPreChatVisuals(true);
                    }
                  }}
                  className="pre-chat-collapse"
                >
                  <Panel header="Pre Chat" key="1">
                    <div>
                      <div className="pre-chat-collapse-item flex_between">
                        <div className="flex_items">
                          <h4>Pre Chat Image</h4>
                        </div>

                        <Upload {...uploadProps} beforeUpload={beforeUpload}>
                          <Button icon={<UploadOutlined />} className="">
                            Upload Image
                          </Button>
                        </Upload>
                      </div>
                      <Divider className="pre-chat-item-divider" />
                      <div className=" pre-chat-collapse-item flex_between">
                        <TextArea
                          value={preChatHeading}
                          rows={2}
                          placeholder="Pre Chat Heading"
                          onChange={(e) => setPreChatHeading(e.target.value)}
                        />
                      </div>

                      <div className=" pre-chat-collapse-item flex_between">
                        <TextArea
                          value={preChatText}
                          rows={2}
                          placeholder="Pre Chat Text"
                          onChange={(e) => setPreChatText(e.target.value)}
                        />
                      </div>
                    </div>
                  </Panel>
                </Collapse>
              </div>
            </Col>
            <Col span={12}>
              <h4>WIDGET PREVIEW</h4>
              <div className={`widget_preview widget-${appearance.position}`}>
                {preChatVisuals ? (
                  <div>
                    <div className="pre-chat-holder">
                      {preChatPreview ? (
                        <ImageContainer
                          imageUrl={preChatPreview}
                          width={230}
                          height={140}
                        />
                      ) : (
                        <ImageContainer
                          imageUrl={image}
                          width={230}
                          height={140}
                        />
                      )}
                      <h3>{preChatHeading ?? "Welcome to chat"}</h3>
                      <p className="pre-chat-text">
                        {preChatText ?? "We just need some basic information"}
                      </p>
                    </div>
                  </div>
                ) : (
                  <>
                    {attGrab && selectedImage && (
                      <div
                        className={`attention-grabber attention-grabber-${appearance.style}-${appearance.position}`}
                      >
                        <img alt="Selected Image" src={selectedImage?.image} />
                      </div>
                    )}

                    <div
                      className={`widget-${appearance.style}`}
                      style={{ backgroundColor: appearance.color }}
                    >
                      {appearance.style === "bubble" ? (
                        <MessageOutlined />
                      ) : (
                        <span>Online</span>
                      )}
                    </div>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Modal>
      )}
    </div>
  );
};

export default React.memo(WidgetAppearance);
